<template>
  <div class="container-fluid">
    <v-header />
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-8 mx-auto d-flex flex-column justify-content-center">
          <h4>
            <span class="highlight highlight-green-300">Connectez-vous</span> à votre espace
          </h4>
          <div class="mb-3">
            Gérez tous vos contrats et souscrivez-en de nouveaux en quelques clics !
          </div>
          <form class="form-signin small">
            <div class="form-label-group mb-2">
              <label
                class="form-label"
                for="inputEmail"
              >
                Adresse email
              </label>
              <input
                id="inputEmail"
                v-model="email"
                type="email"
                class="form-control"
                :class="(!isEmailValid && email != '')? 'is-invalid':''"
                autocomplete="email"
                required
              >
              <transition
                tag="div"
                @enter="tf_slideDown"
                @leave="tf_slideUp"
              >
                <div
                  v-if="!isEmailValid && email !== ''"
                  class="invalid-feedback"
                >
                  Email non valide
                </div>
              </transition>
            </div>

            <transition
              tag="div"
              @enter="tf_slideDown"
              @leave="tf_slideUp"
            >
              <div
                v-if="!obliviate"
                class="form-label-group mb-3"
              >
                <label
                  class="form-label"
                  for="inputPassword"
                >
                  Mot de passe
                </label>
                <div class="input-group">
                  <input
                    id="inputPassword"
                    v-model="password"
                    :type="selected? 'text':'password'"
                    class="form-control border-end-0"
                    autocomplete="current-password"
                    placeholder=""
                    required
                    @keyup.enter="isEmailValid ? login() : ()=> {}"
                  >
                  <div
                    class="cursor-pointer input-group-text bg-white border-start-0"
                    @click="selected = !selected"
                  >
                    <v-icon
                      :icon="selected ? 'eye-blue-500': 'eye-hidden-blue-500'"
                      height="19"
                      width="19"
                    />
                  </div>
                </div>
              </div>
            </transition>
            <transition
              v-if="!obliviate"
              @enter="tf_slideDown"
              @leave="tf_slideUp"
            >
              <div
                v-if="error"
                class="invalid-feedback mb-3"
              >
                {{ error }}
              </div>
            </transition>
          </form>
          <v-loader
            v-if="!obliviate"
            :next="login"
            :disable-button="(!isEmailValid || !password)"
            title="Connexion"
            icon="arrow-white-right"
            class="w-100"
          />
          <v-loader
            v-else
            :next="reset"
            :disable-button="(!isEmailValid)"
            title="Envoyer un lien"
            icon="arrow-white-right"
            class="w-100"
          />
          <div class="d-flex">
            <button
              class="btn btn-block mx-auto mt-2"
              type="button"
              @click="obliviate = !obliviate"
            >
              {{ !obliviate ? 'Mot de passe oublié ?' : 'Connexion' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { routing, transform, ui } from '@/mixins';

import Header from '@/components/common/layout/Header.vue';

import { validateEmail } from '@/utils/validators';

export default {
  name: 'LoginView',
  components: {
    'v-header': Header,
  },
  mixins: [routing, transform, ui],
  data() {
    return {
      title: '',
      email: '',
      password: '',
      loading: false,
      timer: null,
      error: false,
      success: false,
      obliviate: false,
      selected: false,
    };
  },
  computed: {
    isEmailValid() {
      return validateEmail(this.email);
    },
    isLogged() {
      return this.$store.state.client.isLogged;
    },
    isBroker() {
      return this.$store.state.client.isBroker;
    },
    changeAccount() {
      return this.$store.getters.changeAccount;
    },
  },
  mounted() {
    if (this.isLogged && !this.changeAccount) {
      const path = this.$route.query.redirect || '/client';
      this.$router.replace(path);
    }
    if (this.$route.params.from === 'error') {
      this.title = 'Un compte existe déjà pour cette entreprise, veuillez vous connecter';
    }
    this.$store.dispatch('ui/setAssistantMessage', null);
  },
  methods: {
    async login() {
      this.error = '';
      const { email, password } = this;
      try {
        await this.$store.dispatch('client/login', { email, password });
        await this.$store.dispatch('setValue', { changeAccount: false });
        if (this.isBroker) {
          return window.location.assign(import.meta.env.VITE_WIDGET_URL);
        }
        const path = this.$route.query.redirect || '/client';
        const haveSignature = await this.$store.dispatch('company/getDocumentsToBeSigned');
        if (haveSignature) {
          return this.$router.replace('/client/signature');
        }
        return this.$router.replace(path);
      } catch (err) {
        this.error = 'Aucun utilisateur n\'a été trouvé';
        if (err.response) {
          if (err.response.status === 403 || err.response.status === 401) {
            this.error = 'Veuillez vérifier les informations de connexion';
          }
          if (err.response.status === 500) {
            this.error = 'Service indisponible';
          }
        }
        throw (err);
      }
    },
    async reset() {
      await this.$store.dispatch('client/resetLink', this.email);
      await this.ui_showToast({
        show: true,
        message: 'Une demande de réinitialisation a été envoyé',
      });
      this.obliviate = !this.obliviate;
    },
  },
};
</script>
